import BaseRegulation from "../base_regulation";

export default abstract class COMBaseRegulation extends BaseRegulation{
    static CLASS = 'COMBaseRegulation';
}